<template>
    <base-nav class="navbar-top no-print"
              id="navbar-main"
              :show-toggle-button="false"
              expand>
        <!--<form class="navbar-search navbar-search-dark form-inline mr-3 d-none d-md-flex ml-lg-auto">
            <div class="form-group mb-0">
                <base-input placeholder="Search"
                            class="input-group-alternative"
                            alternative=""
                            addon-right-icon="fas fa-search">
                </base-input>
            </div>
        </form>-->
        <div class=" ml-lg-auto"></div>
        <ul class="navbar-nav align-items-center d-none d-md-flex">
            <li class="nav-item dropdown">
                <base-dropdown class="nav-link pr-0">
                    <div class="media align-items-center clickable" slot="title">
                        <span class="avatar avatar-sm rounded-circle no-print">
                          <img :alt="info_usuario.nome" :src="info_usuario.avatar">
                        </span>
                        <div class="media-body ml-2 d-none d-lg-block">
                            <span class="mb-0 text-sm font-weight-bold">{{info_usuario.nome}}</span>
                        </div>
                    </div>

                    <template>
                        <div class=" dropdown-header noti-title">
                            <h6 class="text-overflow m-0">Bem vindo(a)!</h6>
                        </div>
                        <!-- <router-link to="/conta" class="dropdown-item">
                            <i class="ni ni-single-02"></i>
                            <span>Minha conta</span>
                        </router-link> -->
                        <div class="dropdown-divider"></div>
                         <router-link to="/alterar-senha" class="clickable dropdown-item">
                          <i class="fas fa-key"></i>
                            <span>Alterar Senha</span>
                          </router-link>
                        <div class="clickable dropdown-item" @click="logoff()">
                            <i class="fas fa-sign-out-alt"></i>
                            <span>Deslogar</span>
                        </div>
                    </template>
                </base-dropdown>
            </li>
        </ul>
    </base-nav>
</template>
<script>
  import storage from "storage";
  import usuario from "@/cflow/usuario.js";
  import router from '@/router'
  export default {
    data() {
      return {
        activeNotifications: false,
        showMenu: false,
        searchQuery: '',
        info_usuario:{
          nome: storage.get("user","nome"),
          avatar: storage.get("user","avatar")
        }
      };
    },
    methods: {
      toggleSidebar() {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      },
      hideSidebar() {
        this.$sidebar.displaySidebar(false);
      },
      toggleMenu() {
        this.showMenu = !this.showMenu;
      },
      logoff(){
        usuario.logoff();
        router.push('/login');
      }
    }
  };
</script>
